import React, { useState } from "react";
import { runVirtualOnce, backtestVirtual } from "../services/virtual.js";

export default function VirtualBotPanel(){
  const [tickers, setTickers] = useState("AAPL,MSFT,GOOGL");
  const [tp, setTp] = useState(2.0);
  const [sl, setSl] = useState(1.0);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [log, setLog] = useState("");

  const runOnce = async () => {
    setLog("Starte Analyse…");
    try{
      const res = await runVirtualOnce({ tickers: tickers.split(',').map(s=>s.trim()).filter(Boolean), tp_pct: tp, sl_pct: sl });
      setLog(JSON.stringify(res, null, 2));
    }catch(e){ setLog(`Fehler: ${e.message}`); }
  };

  const runBacktest = async () => {
    setLog("Backtest läuft…");
    try{
      const res = await backtestVirtual({
        tickers: tickers.split(',').map(s=>s.trim()).filter(Boolean),
        tp_pct: tp, sl_pct: sl, start: start || undefined, end: end || undefined
      });
      setLog(JSON.stringify(res, null, 2));
    }catch(e){ setLog(`Fehler: ${e.message}`); }
  };

  return (
    <div className="card">
      <div className="font-semibold mb-2">Virtueller Bot</div>
      <div className="space-y-2 text-sm">
        <label className="block">Tickers (CSV)
          <input className="w-full border rounded px-2 py-1" value={tickers} onChange={e=>setTickers(e.target.value)} />
        </label>
        <div className="grid grid-cols-2 gap-2">
          <label>TP %
            <input type="number" step="0.1" className="w-full border rounded px-2 py-1" value={tp} onChange={e=>setTp(e.target.value)} />
          </label>
          <label>SL %
            <input type="number" step="0.1" className="w-full border rounded px-2 py-1" value={sl} onChange={e=>setSl(e.target.value)} />
          </label>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <label>Start
            <input type="date" className="w-full border rounded px-2 py-1" value={start} onChange={e=>setStart(e.target.value)} />
          </label>
          <label>Ende
            <input type="date" className="w-full border rounded px-2 py-1" value={end} onChange={e=>setEnd(e.target.value)} />
          </label>
        </div>
        <div className="flex gap-2">
          <button className="btn btn-primary" onClick={runOnce}>Run once</button>
          <button className="btn btn-muted" onClick={runBacktest}>Backtest & speichern</button>
        </div>
        <pre className="text-xs bg-gray-100 p-2 rounded overflow-auto max-h-64">{log}</pre>
      </div>
    </div>
  );
}
